import { actionsType } from './actions';
import { ReduxAction, ReduxState } from './interface';

const stateInit: ReduxState = {
    drawerMenuStatus: false,
    genrse: undefined,
    filters: {
        genre: null,
        query: null,
    },
    pagination: {
        page: 1,
    },
};

const reducer = (
    state: ReduxState = stateInit,
    action: ReduxAction
): ReduxState => {
    switch (action.type) {
        case actionsType.toggleDrawerMenu:
            return {
                ...state,
                drawerMenuStatus: !state.drawerMenuStatus,
            };
        case actionsType.getAllGenres:
            return {
                ...state,
                genrse: action.payload,
            };
        case actionsType.getFilters:
            return {
                ...state,
                filters: action.payload,
            };
        case actionsType.getPagination:
            return {
                ...state,
                pagination: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default reducer;
